<sh-form-group
  [invalid]="isControlInvalid$ | async"
  [required]="isControlRequired$ | async"
  [label]="label"
  [labelIcons]="labelIcons"
  [helpText]="helpText"
  [currentActionItems]="currentActionItems"
  [describeLabelId]="describeLabelId"
  [errorMsg]="errorMsg"
  [id]="controlId"
  [formGroupStyling]="formGroupStyling"
  >
  <div slot="inputPrefix">
    <ng-content></ng-content>
  </div>

  @if (canBeIndeterminate) {
    <sh-form-multi-select-complex-base
      [id]="controlId"
      [required]="isControlRequired$ | async"
      [formControl]="control"
      [options]="options"
      [search]="search"
      [multiple]="multiple"
      [height]="height"
      [itemCapCount]="itemCapCount"
      [selectionLimit]="selectionLimit"
      [hiddenItemCount]="hiddenItemCount"
      [openDirection]="openDirection"
      [isLoading]="isLoading"
      [loadingMsg]="loadingMsg"
      [noneSelectedMsg]="noneSelectedMsg"
      [multipleSelectedMsg]="multipleSelectedMsg"
      [allSelectedMsg]="allSelectedMsg"
      [placeholderMsg]="placeholderMsg"
      [searchPlaceholderMsg]="searchPlaceholderMsg"
      [selectionLimitMessageKey]="selectionLimitMessageKey"
      [indeterminateMsg]="indeterminateMsg"
      [noResultsFoundMsg]="noResultsFoundMsg"
      [allowSingleDeselect]="allowSingleDeselect"
      [prefixMsg]="prefixMsg"
      [listCappedMsg]="listCappedMsg"
      [inOverflownContainer]="inOverflownContainer"
      [limitHeightToViewport]="limitHeightToViewport"
      [noResultsActionItem]="noResultsActionItem"
      [sortAlphabetically]="sortAlphabetically"
      [style]="style"
      [wrapLabel]="wrapLabel"
      [disabledMsg]="disabledMsg"
      [ngClass]="{ 'sh-input-field-with-action__input': currentActionItems }"
      (searchTerm)="onSearchTermChange($event)"
      (shownItemCount)="onShownItemCountChange($event)"
      [autocompleteFct]="autocompleteFct"
    ></sh-form-multi-select-complex-base>
  } @else {
    <sh-form-multi-select-base
      [id]="controlId"
      [required]="isControlRequired$ | async"
      [formControl]="control"
      [options]="options"
      [search]="search"
      [multiple]="multiple"
      [unwrapList]="unwrapList"
      [height]="height"
      [itemCapCount]="itemCapCount"
      [selectionLimit]="selectionLimit"
      [hiddenItemCount]="hiddenItemCount"
      [openDirection]="openDirection"
      [isLoading]="isLoading"
      [loadingMsg]="loadingMsg"
      [noneSelectedMsg]="noneSelectedMsg"
      [multipleSelectedMsg]="multipleSelectedMsg"
      [allSelectedMsg]="allSelectedMsg"
      [selectionLimitMessageKey]="selectionLimitMessageKey"
      [allowSingleDeselect]="allowSingleDeselect"
      [placeholderMsg]="placeholderMsg"
      [searchPlaceholderMsg]="searchPlaceholderMsg"
      [noResultsFoundMsg]="noResultsFoundMsg"
      [prefixMsg]="prefixMsg"
      [listCappedMsg]="listCappedMsg"
      [inOverflownContainer]="inOverflownContainer"
      [limitHeightToViewport]="limitHeightToViewport"
      [noResultsActionItem]="noResultsActionItem"
      [sortAlphabetically]="sortAlphabetically"
      [style]="style"
      [wrapLabel]="wrapLabel"
      [disabledMsg]="disabledMsg"
      [ngClass]="{ 'sh-input-field-with-action__input': currentActionItems }"
      (searchTerm)="onSearchTermChange($event)"
      (shownItemCount)="onShownItemCountChange($event)"
      [autocompleteFct]="autocompleteFct"
    ></sh-form-multi-select-base>
  }

</sh-form-group>
